import * as React from "react";

export class ReportsRedirect extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            redirectedFrom: "",
        };
    }

    componentDidMount() {
        const location = this.props.location;
        if (location.state !== undefined) {
            let stateLength = Object.keys(location.state).length;
            if (stateLength > 0) {
                let redirectedFrom = location.state.product;
                this.setState({ redirectedFrom }, () => {
                    this.props.history.push("/Reports", {
                        product: this.state.redirectedFrom,
                    });
                });
            } else {
                this.props.history.push("/Reports", {});
            }
        } else {
            this.props.history.push("/Reports", {});
        }
    }

    render() {
        return (
            <></>
        )
    }
}